import { defineMessages } from 'react-intl';

export default defineMessages({
    modalTitle: {
        id: '_.iwocapay.draw_down.step_buttons.action_applicant_call_modal_title',
        defaultMessage: 'Give us a quick call'
    },
    availabilityMessageLineOne: {
        id: '_.iwocapay.draw_down.step_buttons.action_applicant_call_modal.availability_message_line_one',
        defaultMessage: 'Mon - Fri'
    },
    timesForMessageLineOne: {
        id: '_.iwocapay.draw_down.step_buttons.action_applicant_call_modal.times_for_message_line_one',
        defaultMessage: '8am - 7pm'
    },
    availabilityMessageLineTwo: {
        id: '_.iwocapay.draw_down.step_buttons.action_applicant_call_modal.availability_message_line_two',
        defaultMessage: 'Saturday'
    },
    timesForMessageLineTwo: {
        id: '_.iwocapay.draw_down.step_buttons.action_applicant_call_modal.times_for_message_line_two',
        defaultMessage: '9am - 3pm'
    },
    displayPhoneNumber: {
        id: '_.iwocapay.draw_down.step_buttons.action_applicant_call_modal.displayPhoneNumber',
        defaultMessage: '020 3778 0549'
    },
    callPhoneNumber: {
        id: '_.iwocapay.draw_down.step_buttons.action_applicant_call_modal.callPhoneNumber',
        defaultMessage: '+44-0203-778-0549'
    },
    callSubText: {
        id: '_.iwocapay.draw_down.step_buttons.action_applicant_call_modal.call_sub_text',
        defaultMessage:
            "You're nearly there. Based on your application so far, you'll need to call your account manager to finish the last step."
    }
});
